export function copyCanvasFrame(
  source: HTMLCanvasElement,
  destination: HTMLCanvasElement,
): boolean {
  if (source.width <= 0 || source.height <= 0) return false;

  destination.width = source.width;
  destination.height = source.height;

  const context = destination.getContext("2d");
  if (!context) {
    releaseCanvasFrame(destination);
    return false;
  }

  try {
    context.drawImage(source, 0, 0, source.width, source.height);
    return true;
  } catch {
    releaseCanvasFrame(destination);
    return false;
  }
}

export function releaseCanvasFrame(canvas: HTMLCanvasElement): void {
  canvas.width = 1;
  canvas.height = 1;
}

export function canRevealThreeDContent({
  active,
  sceneMounted,
  firstFrameReady,
  modelsLoading,
}: {
  active: boolean;
  sceneMounted: boolean;
  firstFrameReady: boolean;
  modelsLoading: boolean;
}): boolean {
  return active && sceneMounted && firstFrameReady && !modelsLoading;
}

export const canRestoreThreeDMeasurements = canRevealThreeDContent;
